import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";
export default class Block10 {
  static selector = ".block-10";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.titleNode = this.block.querySelector(".block-10__title");
    this.imageNode = this.block.querySelector(".block-10__image");
    this.textNode = this.block.querySelector(".block-10__image__caption .text");
    this.creditsNode = this.block.querySelector(
      ".block-10__image__caption .credits"
    );

    this.attributes = attrs;
  }

  setupTitle = (title) => {
    if (title) {
      title.split("").forEach((character) => {
        const span = document.createElement("span");
        span.textContent = character;
        this.titleNode.appendChild(span);
      });

      if (this.attributes.parallax) {
        this.titleNode.dataset.hugeTextParallax = true;
      }
    } else {
      this.titleNode.remove();
    }
  };

  setupImage = async (image) => {
    return new Promise(async (resolve) => {
      if (image) {
        await new CustomImage(
          this.imageNode.querySelector(".image"),
          this.attributes.image
        ).onReady();

        await new Text(this.textNode, this.attributes.text).onReady();

        await new Credits(this.creditsNode, this.attributes.credits).onReady();
      } else {
        this.imageNode.remove();
      }

      resolve();
    });
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      this.setupTitle(this.attributes.title);

      await this.setupImage(this.attributes.image);

      resolve();
    });
  };

  onReady = () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
